export default __webpack_public_path__ + "static/logo-a0dc7549f09bfd858d6b2196fa569207.png";